import {
    httpGetProjectExtensionRequestData,
    HttpGetProjectExtensionRequestDataResponse
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

interface UseGetExtensionRequestDataOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<
        UseQueryOptions<HttpGetProjectExtensionRequestDataResponse, AxiosError<ErrorResponseData>>,
        'queryKey' | 'queryFn'
    >
}

export const useGetExtensionRequestData = ({urlParams, options}: UseGetExtensionRequestDataOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.PROJECT_EXTENSION_REQUEST_DATA, urlParams.projectId],
        queryFn: () => httpGetProjectExtensionRequestData({urlParams}),
        ...options
    })
